import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  ChangePricesForSeasonRatesRequest,
  CopySeasonRatesFromAccommodationToAnotherRequest,
  CopySeasonRatesToNextSalesPeriodRequest,
  ModifyAdditionalServiceRulesRequest,
  ModifyDatesForSeasonRatesRequest,
  RevertSeasonRateCopyRequest,
  RevertSeasonRateDateChangeRequest,
} from '../../features/seasonRateTools/rateToolsSlice';
import { SEASON_RATE_BATCH_OPERATION_TYPE } from '../constants';

const rateToolsService = {
  copySeasonRatesToNextSalesPeriodRequest: async (
    data: CopySeasonRatesToNextSalesPeriodRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copySeasonRatesToNextSalesPeriod',
      data,
      config,
    );
    return response.data;
  },
  copySeasonRatesFromAccommodationToAnotherRequest: async (
    data: CopySeasonRatesFromAccommodationToAnotherRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/copySeasonRatesFromAccommodationToAnother',
      data,
      config,
    );
    return response.data;
  },
  doChangePricesForSeasonRates: async (
    data: ChangePricesForSeasonRatesRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/changePricesForSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  doModifyDatesForSeasonRates: async (
    data: ModifyDatesForSeasonRatesRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/modifyDatesForSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  doModifyAdditionalServiceRulesForSeasonRates: async (
    data: ModifyAdditionalServiceRulesRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/modifyAdditionalServiceRulesForSeasonRates',
      data,
      config,
    );
    return response.data;
  },
  getSeasonRateBatchUpdateDetails: async (
    operationType?: SEASON_RATE_BATCH_OPERATION_TYPE,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: { operationType },
    };

    const response = await axios.get(
      '/pricing/ratetools/getSeasonRateBatchUpdateDetails',
      config,
    );
    return response.data;
  },
  getLastBatchOperationForTag: async (
    tagId: string,
    operationType: SEASON_RATE_BATCH_OPERATION_TYPE,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: { tagId, operationType },
    };

    const response = await axios.get(
      '/pricing/ratetools/getLastBatchOperationForTag',
      config,
    );
    return response.data;
  },
  revertSeasonRateCopy: async (data: RevertSeasonRateCopyRequest) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/revertSeasonRateCopy',
      data,
      config,
    );
    return response.data;
  },
  revertSeasonRateDateChange: async (
    data: RevertSeasonRateDateChangeRequest,
  ) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/pricing/ratetools/revertSeasonRateDateChange',
      data,
      config,
    );
    return response.data;
  },
  getRevertPreview: async (batchUpdateDetailId: string) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: { batchUpdateDetailId },
    };

    const response = await axios.get(
      '/pricing/ratetools/getRevertPreview',
      config,
    );
    return response.data;
  },
};

export default rateToolsService;
